export const SkillTabIndexType = {
    PROFICIENCY: 0,
    CONTENT: 1,
    ROLES: 2,
    PERSONA: 3,
    ASSESSMENT: 4
};
